import React, { useState } from 'react'
import { VStack, Link } from '@chakra-ui/react'
import { ExternalContentModal } from './ExternalContentModal'

export const FooterLinks = () => {
  const [isCommercialModalOpen, setIsCommercialModalOpen] = useState(false)
  const [isFundSettlementModalOpen, setIsFundSettlementModalOpen] = useState(false)

  return (
    <>
      <VStack w="100%" py="24px" gap={3} align="center">
        <Link onClick={() => setIsCommercialModalOpen(true)} color="label.link" fontSize="sm" textDecoration="underline" lineHeight="18px" cursor="pointer">
          特定商取引法の表記
        </Link>
        <Link onClick={() => setIsFundSettlementModalOpen(true)} color="label.link" fontSize="sm" textDecoration="underline" lineHeight="18px" cursor="pointer">
          資金決済法に基づく表示
        </Link>
      </VStack>

      <ExternalContentModal
        isOpen={isCommercialModalOpen}
        onClose={() => setIsCommercialModalOpen(false)}
        url="/external_payment/coin_purchase/company"
        title="特定商取引法の表記"
      />

      <ExternalContentModal
        isOpen={isFundSettlementModalOpen}
        onClose={() => setIsFundSettlementModalOpen(false)}
        url="/external_payment/coin_purchase/fund_settlement"
        title="資金決済法に基づく表示"
      />
    </>
  )
}
